import axiosInstance from '../../utils/axiosConfig';

// Action types
export const GET_INVESTIGATION_ACTION = 'GET_INVESTIGATION_ACTION';
export const GET_INVESTIGATION_ACTION_BY_ID = 'GET_INVESTIGATION_ACTION_BY_ID';
export const GET_INVESTIGATION_ACTIONS_ENUM = 'GET_INVESTIGATION_ACTIONS_ENUM';
export const CREATE_INVESTIGATION_ACTION = 'CREATE_INVESTIGATION_ACTION';
export const CREATE_LIST_INVESTIGATION_ACTION = 'CREATE_LIST_INVESTIGATION_ACTION';
export const DELETE_INVESTIGATION_ACTION = 'DELETE_INVESTIGATION_ACTION';
export const UPDATE_INVESTIGATION_ACTION = 'UPDATE_INVESTIGATION_ACTION';
export const GET_INVESTIGATION_ACTIONS_BY_INVESTIGATION_ID = 'GET_INVESTIGATION_ACTIONS_BY_INVESTIGATION_ID'; // New action type

const API_URL = `${process.env.REACT_APP_BACKEND_URL_MS_INVESTIGATION}/investigationAction`;
const ENUM_URL = `${API_URL}/investigationActionsEnum`;
const LIST_URL = `${process.env.REACT_APP_BACKEND_URL_MS_INVESTIGATION}/listInvestigationAction`;

// Action creators

// Get all investigation actions
export const getAllInvestigationAction = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(API_URL);
    console.log('Fetched investigation actions:', response.data);
    dispatch({
      type: GET_INVESTIGATION_ACTION,
      payload: response.data,
    });
  } catch (error) {
    console.error('Error fetching investigation actions:', error);
  }
};

// Get an investigation action by ID
export const getInvestigationActionById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${id}`);
    dispatch({
      type: GET_INVESTIGATION_ACTION_BY_ID,
      payload: response.data,
    });
  } catch (error) {
    console.error(`Error fetching investigation action by ID ${id}:`, error);
  }
};

// Get all investigation actions enum
export const getAllInvestigationActionsEnum = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(ENUM_URL);
    dispatch({
      type: GET_INVESTIGATION_ACTIONS_ENUM,
      payload: response.data,
    });
  } catch (error) {
    console.error('Error fetching investigation actions enum:', error);
  }
};

// Create a new investigation action
export const createInvestigationAction = (investigation) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(API_URL, investigation);
    dispatch({
      type: CREATE_INVESTIGATION_ACTION,
      payload: response.data,
    });
  } catch (error) {
    console.error('Error creating investigation action:', error);
  }
};

// Create a list of investigation actions
export const createListInvestigationAction = (investigations) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(LIST_URL, investigations);
    dispatch({
      type: CREATE_LIST_INVESTIGATION_ACTION,
      payload: response.data,
    });
  } catch (error) {
    console.error('Error creating list of investigation actions:', error);
  }
};

// Update an existing investigation action
export const updateInvestigationAction = (id, updatedInvestigation) => async (dispatch) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${id}`, updatedInvestigation);
    dispatch({
      type: UPDATE_INVESTIGATION_ACTION,
      payload: response.data,
    });
  } catch (error) {
    console.error(`Error updating investigation action ID ${id}:`, error);
  }
};

// Delete an investigation action
export const deleteInvestigationAction = (id) => async (dispatch) => {
  try {
    await axiosInstance.delete(`${API_URL}/${id}`);
    dispatch({
      type: DELETE_INVESTIGATION_ACTION,
      payload: id,
    });
  } catch (error) {
    console.error(`Error deleting investigation action ID ${id}:`, error);
  }
};

// Get investigation actions by investigation ID
export const getInvestigationActionsByInvestigationId = (idInvestigation) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/investigation/${idInvestigation}`);
    dispatch({
      type: GET_INVESTIGATION_ACTIONS_BY_INVESTIGATION_ID,
      payload: response.data,
    });
  } catch (error) {
    console.error(`Error fetching investigation actions by investigation ID ${idInvestigation}:`, error);
  }
};
